module.exports = __webpack_public_path__ + "395943b09be15f7dcca6b55fc3be4f3e.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/NF.svg
// module id = o5/R
// module chunks = 0